<script lang="ts">
    import { classMap } from "@smui/common/internal";

    import Select, { Option } from "@smui/select";
    import Icon from "@smui/select/icon";
    import { _ } from "svelte-i18n";
    import { createEventDispatcher } from "svelte";

    let className = "";
    export { className as class };
    export let value;
    export let list = [];
    export let format = { showId: false, translateName: true };
    export let errorMsg = false;
    export let required = false;
    export let disabled = false;
    export let noLabel = true;
    export let style = "";
    export let colspan = 1;
    export let data_qa = "dt-select-cell";

    const dispatch = createEventDispatcher();

    let edEl;
    let menuWidth;
    let menuBottom;

    const formatOptionName = (item) => {
        if (format?.showId) {
            return [item.id, format?.translateName ? $_(item.name) : item.name].join(" - ");
        } else {
            return format?.translateName ? $_(item.name) : item.name;
        }
    };
</script>

<div
    class={classMap({
        [className]: true,
        "select-cell": true,
    })}
    {style}
    {colspan}
>
    {#if list && list.length > 0}
        <Select
            variant="outlined"
            bind:value
            bind:this={edEl}
            {noLabel}
            {required}
            {disabled}
            fullWidth={false}
            data-qa={data_qa}
            class="tescoblue-text white with-parameter w-100 bs-bb outlined"
            style="--mdc-menu-min-width: {menuWidth}px; --mdc-menu-top: {menuBottom}px"
            menu$class="mdc-menu-surface--fixed with-parameter__menu"
            on:SMUISelect:change={() => {
                dispatch("change");
            }}
            on:focusin={() => {
                //console.log("In Focus", {edEl});
                menuWidth = edEl?.getElement()?.clientWidth;
                menuBottom = edEl?.getElement()?.getBoundingClientRect()?.bottom;
            }}
            on:click={() => {
                menuWidth = edEl?.getElement()?.clientWidth;
                menuBottom = edEl?.getElement()?.getBoundingClientRect()?.bottom;
            }}
            on:SMUISelect:change
            updateInvalid={false}
            invalid={errorMsg}
            withLeadingIcon={errorMsg}
        >
            {#each list as item}
                <Option value={item.id}>{formatOptionName(item)}</Option>
            {/each}
            <svelte:fragment slot="leadingIcon">
                {#if errorMsg}
                    <Icon class="material-icons red-text">error</Icon>
                {/if}
            </svelte:fragment>
        </Select>
    {/if}
</div>
